<template>
  <b-card>
    <h4 class="mb-2">
      <font-awesome-icon class="mr-50 ml-1" icon="fa-solid fa-calculator" /> 財務管理
    </h4>
    <b-tabs class="finance-tabs" pills >

      <b-tab active v-if="ability.can('read', 'settings_finance_banks')">
        <template #title>
          <font-awesome-icon icon="fa-solid fa-building-columns" class="mr-0 mr-sm-50 d-inline d-sm-none" />
          <span class="d-none d-sm-inline">銀行管理</span>
        </template>

        <banks-list class="" />
      </b-tab>
      <!-- Tab: receive methods -->
      <b-tab v-if="ability.can('read', 'settings_finance_receive_methods')">
        <template #title>
          <font-awesome-icon icon="fa-solid fa-credit-card" class="mr-0 mr-sm-50 d-inline d-sm-none" />
          <span class="d-none d-sm-inline">付款方式管理</span>
        </template>

        <receive-methods-list class="" />
      </b-tab>
      <!-- Tab: claim status -->
      <b-tab v-if="ability.can('read', 'settings_finance_claims')">
        <template #title>
          <font-awesome-icon
            icon="fa-solid fa-people-carry-box"
            class="mr-0 mr-sm-50 d-inline d-sm-none"
          />
          <span class="d-none d-sm-inline">報銷狀態</span>
        </template>

        <claim-statuses-list class="" />
      </b-tab>
      <!-- Tab: expense status -->
      <b-tab v-if="ability.can('read', 'settings_finance_expenditures')">
        <template #title>
          <font-awesome-icon
            icon="fa-solid fa-people-carry-box"
            class="mr-0 mr-sm-50 d-inline d-sm-none"
          />
          <span class="d-none d-sm-inline">薪金支出狀態</span>
        </template>

        <expense-statuses-list class="" />
      </b-tab>
      <!-- Tab: prepayment status-->
      <b-tab v-if="ability.can('read', 'settings_finance_prepayments')">
        <template #title>
          <font-awesome-icon
            icon="fa-solid fa-truck-field"
            class="mr-0 mr-sm-50 d-inline d-sm-none"
          />
          <span class="d-none d-sm-inline">預支狀態</span>
        </template>

        <prepayment-statuses-list class="" />
      </b-tab>
      <!-- Tab: document type-->
     
    </b-tabs>
  </b-card>
</template>

<script>
import { BCard, BAlert, BLink, BTabs, BTab } from "bootstrap-vue";
import claimStatusesList from "./claim-status/claim-statuses-list/claimStatusesList.vue";
import expenseStatusesList from "./expense-status/expense-statuses-list/expenseStatusesList.vue";
import prepaymentStatusesList from "./prepayment-status/prepayment-statuses-list/prepaymentStatusesList.vue";
import banksList from "./bank/banks-list/banksList.vue";
import receiveMethodsList from "./receive-methods/receive-methods-list/receiveMethodsList.vue";
import ability from "@/libs/acl/ability";

export default {
  components: {
    claimStatusesList,
    expenseStatusesList,
    prepaymentStatusesList,
    banksList,
    receiveMethodsList,
    BCard,
    BAlert,
    BTabs,
    BTab,
    BLink,
  },
  data() {
    return {
      ability,
    };
  },
  setup() {},
};
</script>
<style lang="scss" >
// .finance-tabs.tabs:not(.type-1) .nav-pills .nav-item {
//     margin-left: 1rem;
// }
</style>